import React from 'react'
import { useTranslation } from 'react-i18next'

export default function TriggerCard({ playbook, canWrite, onChange }) {
  const { t } = useTranslation()
  const trigger = playbook.trigger ?? {}
  const keywords = Array.isArray(trigger.keywords) ? trigger.keywords : []
  const [draftKeyword, setDraftKeyword] = React.useState('')
  const [notice, setNotice] = React.useState(false)

  function commitKeyword(value = draftKeyword) {
    const next = value.trim()
    if (!next) return
    const additions = next.split(',').map((item) => item.trim()).filter(Boolean)
    const merged = [...keywords]
    let dropped = false
    additions.forEach((item) => {
      if (item.length > 40 || (!merged.includes(item) && merged.length >= 10)) { dropped = true; return }
      if (!merged.includes(item)) merged.push(item)
    })
    setNotice(dropped)
    onChange?.({ trigger: { ...trigger, keywords: merged } })
    setDraftKeyword('')
  }

  function removeKeyword(keyword) {
    onChange?.({ trigger: { ...trigger, keywords: keywords.filter((item) => item !== keyword) } })
  }

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5">
      <h2 className="text-base font-semibold">{t('playbook.cards.trigger')}</h2>
      <label className="mt-3 flex flex-col gap-1 text-sm font-medium">{t('playbook.fields.description')}
        <textarea aria-label={t('playbook.fields.description')} rows={3} value={trigger.description ?? ''} disabled={!canWrite} onChange={(event) => onChange?.({ trigger: { ...trigger, description: event.target.value } })} className="rounded-lg border border-slate-300 p-2 text-sm" />
      </label>
      <div className="mt-4 flex flex-col gap-2 text-sm font-medium">
        <span>{t('playbook.fields.keywords')}</span>
        <div className="flex min-h-10 flex-wrap items-center gap-2 rounded-lg border border-slate-300 px-2 py-1.5 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/10">
          {keywords.map((keyword) => (
            <span key={keyword} className="inline-flex max-w-full items-center gap-1 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-700">
              <span className="max-w-[16rem] truncate">{keyword}</span>
              <button type="button" className="rounded-full px-1 text-slate-500 hover:bg-slate-200 hover:text-slate-900 disabled:cursor-not-allowed disabled:opacity-40" disabled={!canWrite} aria-label={t('playbook.fields.removeKeyword', { keyword })} onClick={() => removeKeyword(keyword)}>×</button>
            </span>
          ))}
          <input
            aria-label={t('playbook.fields.addKeyword')}
            value={draftKeyword}
            disabled={!canWrite || keywords.length >= 10}
            placeholder={keywords.length ? t('playbook.fields.addKeyword') : t('playbook.fields.keywordsPlaceholder')}
            onChange={(event) => setDraftKeyword(event.target.value)}
            onBlur={() => commitKeyword()}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ',') {
                event.preventDefault()
                commitKeyword()
              }
              if (event.key === 'Backspace' && !draftKeyword && keywords.length) removeKeyword(keywords[keywords.length - 1])
            }}
            className="min-w-[12rem] flex-1 border-0 bg-transparent px-1 py-1 text-sm outline-none placeholder:text-slate-400"
          />
        </div>
        <span className={`text-xs font-normal ${notice ? 'text-amber-700' : 'text-slate-500'}`}>{notice ? t('playbook.fields.keywordsDropped') : t('playbook.fields.keywordsHint')}</span>
      </div>
    </section>
  )
}

